import { getAPI } from '../utils/ApiFunctions';
import { getAccessToken } from '../utils/Auth.util';
import { MICRO_FRONTEND_STARGATE_KEY } from '../constants/index';

/**
 * calls ui-utils /features endpoints to get feature-flags that are relevant to microfrontend.
 */
class FeaturesService {
    getFeatures = async (stargateToken) => {
        let response;
        try {
            const url = process.env.FEATURES_ENDPOINT;
            const token = stargateToken
                ? stargateToken
                : await getAccessToken(MICRO_FRONTEND_STARGATE_KEY);
            response = await getAPI(url, null, token);

            if (response instanceof Error) {
                console.error(
                    `Call to Ui-Utils Service features endpoint failed with error ${response.message}`
                );
            }
        } catch (error) {
            console.error(error.message);
        }

        return response;
    };
}

export default new FeaturesService();
